<template>
    <div>
        <!--客户对账-->
        <header class="form-title">
            <Row>
                <Col span="24">
                    <Form  inline  :label-width="100" >
                        <FormItem  label="当前客户：" style="margin-right: 30px">
                            <router-link to="" @click.native="isShowDrawer=true"><strong style="color: #00a1ff">{{SupplierName}}</strong>
                                <Icon size="26" color="#00a1ff" type="md-arrow-dropright"  style="position: relative;top: 3px;" /></router-link>
                        </FormItem>
                        <FormItem  label="单据类型：" style="margin-right: 30px">
                            <Select style="width: 200px"
                                    placeholder="全部单据"
                                    v-model="Bill"
                                    @on-change="getDebtList(page,rows,valuedate[0],valuedate[1],SupplierId)">
                                <Option value="" >全部单据</Option>
                                <Option :value="0">非欠款单据</Option>
                                <Option :value="1">欠款单据</Option>
                                <Option :value="2">收款单据</Option>
                            </Select>
                        </FormItem>

                        <FormItem  label="选择时间：" style="margin-right: 30px">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="handleOk"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>
                        <FormItem label="店铺" v-if="isCustomerSharing==1">
                            <Select v-model="shopName" filterable style="width: 200px">
                                <Option
                                        v-if="k.isCustomerSharing==1 || k.isgeneralwarehouse=='Y'"
                                        :value="k.id"
                                        v-for="(k,v) in shopList"
                                        :key="v">{{k.name}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem  label="总欠款：" style="margin-right: 30px">
                            <div>
                                <strong class="result" v-if="overdrawMonery<=0">￥{{Math.abs(overdrawMonery)}}</strong>
                                <strong class="result" v-else="overdrawMonery>0">￥-{{overdrawMonery}}</strong>
                                <Button type="warning" @click="shoukuan" style="position: relative;top: 0px;left: 20px" >收款</Button>
                            </div>
                        </FormItem>
                        <FormItem>
                            <Button type="primary" @click="exportExcel(valuedate[0],valuedate[1],SupplierId)">导出excel</Button>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        </header>
        <Row style="margin: 0px 0 20px">
            <Col span="5"  offset="3">交易金额: <strong class="result">￥{{resultMoney.shouldmoney}}</strong></Col>
            <Col span="5">实收金额: <strong class="result">￥{{resultMoney.truemoney}}</strong></Col>
            <Col span="5">应收余额: <strong class="result">￥{{resultMoney.surplusbalance}}</strong></Col>
        </Row>
        <Table stripe :columns="columns" :data="data" :loading="loadingTable">
            <template slot-scope="{ row, index }" slot="action">
                <Button type="primary" size="small" @click="goDetail(row)">详情</Button>
            </template>
        </Table>

        <div class="pageTotal"  >
            <Page :total="pageTotal"
                  :page-size="pageTotal.rows"
                  show-total
                  @on-change="onChangePage" />
        </div>
        <!--供应商对账列表-->
        <Drawer title="客户对账" :closable="false" v-model="isShowDrawer"  width="400" >
            <!--<ButtonGroup shape="circle" size="small" style="margin: 5px auto">
                <Button type="primary" > 全部客户</Button>
                <Button type="primary" > 欠款客户</Button>
                <Button type="primary" > 不欠款客户</Button>
                <Button type="primary" > 预付定金客户</Button>
            </ButtonGroup>-->
            <Input search enter-button placeholder="客户名称" style="margin-bottom: 20px" v-model="DrawerNames"  />
            <Input search enter-button placeholder="客户电话" style="margin-bottom: 20px" v-model="phone"  />


            <Alert type="warning" v-if="SupplierList.length==0">未查询到数据</Alert>
            <Row v-if="SupplierList.length!=0">
                <Col span="12" align="center"><h3>欠款客户</h3></Col>
                <Col span="12" align="center"><h3>客户欠款</h3></Col>
                <Col span="12" align="center"><strong>{{ totalNums}}</strong></Col>
                <Col span="12" align="center"><strong>{{0-totalMoneys}}</strong></Col>
            </Row>
            <Card  v-if="SupplierList.length!=0 && k.isdel!=0" dis-hover  class="supplierList" :class="{supplierList1:k.customerType==1}"  v-for="(k, v) in SupplierList" :key="v" @click.native="modifySupplierName(k,v)">
                <Row >
                    <Col span="16"><h3>{{ k.name }}</h3></Col>
                    <Col span="8"><h3>欠款</h3></Col>
                    <Col span="16">联系电话:{{ k.phone }}</Col>
                    <Col span="8">
                        <strong style="color: #ff5e5e" v-if=" k.money>0">-{{ k.money }}</strong>
                        <strong  v-else >{{ Math.abs(k.money) }}</strong>
                    </Col>
                </Row>
            </Card>
            <div class="pageTotal"  >
                <Page :total="DrawerNamesPage.currpage"
                      :page-size="DrawerNamesPage.rows"
                      show-total
                      @on-change="onGongPageTotal" />
            </div>
        </Drawer>
        <!--付款-->
        <Modal
                v-model="payMoneyModal"
                title="客户结算">
            <Form :label-width="100" inline>
                <FormItem label="客户："  class="payMoneyModal-input" >
                    <strong>{{SupplierName}}</strong>
                </FormItem>
                <FormItem label="客户欠款："  class="payMoneyModal-input" >
                    <strong v-if="overdrawMonery>0">-{{overdrawMonery}}</strong>
                    <strong v-else>{{0-overdrawMonery}}</strong>
                </FormItem>
                <FormItem  label="结算类型："  class="payMoneyModal-input">
                    <strong>销售收入</strong>
                </FormItem>
                <FormItem  label="业务时间："  class="payMoneyModal-input">
                    <strong>{{this.nowTime}}</strong>
                </FormItem>
                <FormItem  label="结算账户：" >
                    <Select style="width: 300px" v-model="BankListValue">
                        <Option v-for="(item,index) in BankList"
                                v-if="!item.bankname.includes('会员')"
                                :value="item.id"
                                :key="index"  placeholder="请选择">{{item.bankname}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="本次付款：">
                    <Input v-model="thisTruemoney"  style="width: 300px" />
                </FormItem>
                <FormItem  label="备注：" >
                    <Input  type="textarea" v-model="fuKanMsg"  style="width: 300px"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" @click="payMoneyModal=false">取消</Button>
                <Button type="primary" @click="payOk()">确认</Button>
            </div>
        </Modal>
        <!--详情-->
        <Modal
                v-model="detailModal"
                width="800"
                title="客户结算详情">
            <Form :label-width="100" inline>
                <FormItem label="客户："  class="payMoneyModal-input" >
                    <strong>{{detailModalData.customerName}}</strong>
                </FormItem>
                <FormItem label="门店："  class="payMoneyModal-input" >
                    <strong>{{doorShip}}</strong>
                </FormItem>
                <FormItem  label="操作人："  class="payMoneyModal-input">
                    <strong>{{detailModalData.operator}}</strong>
                </FormItem>
                <FormItem  label="总欠款："  class="payMoneyModal-input">
                    <strong >{{detailModalData.actualMoney-detailModalData.surplusSmoneys}}</strong>
                </FormItem>
                <FormItem  label="本次付款："  class="payMoneyModal-input">
                    <strong>{{detailModalData.actualMoney}}</strong>
                </FormItem>
                <FormItem  label="尚欠款："  class="payMoneyModal-input">
                    <strong v-if="detailModalData.surplusSmoneys>0">-{{ detailModalData.surplusSmoneys}}</strong>
                    <strong v-else>{{0- detailModalData.surplusSmoneys}}</strong>
                </FormItem>
                <FormItem  label="结算账户："  class="payMoneyModal-input">
                <strong>{{detailModalData.bankName}}</strong>
            </FormItem>
                <!--<FormItem  label="结算类型："  class="payMoneyModal-input">
                    <strong>{{detailModalData.tableType}}</strong>
                </FormItem>-->
                <FormItem  label="业务时间："  >
                    <strong>{{detailModalData.time}}</strong>
                </FormItem>

                <FormItem  label="单号："  >
                    <strong>{{detailModalData.order}}</strong>
                </FormItem>
                <FormItem  label="备注："  style=" display: block">
                    <strong>{{ detailModalData.remark ? detailModalData.remark.replace(/\[.*?\]|\{.*?\}/g, ''):'' }}</strong>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button  @click="detailModal=false">取消</Button>
                <!-- <Button style="background-color: rgb(241,102, 67);color: white;"  @click="revoke">撤销</Button> -->
            </div>
        </Modal>
    </div>
</template>
<script>
import { exportExcel } from '@/common/exportExcel';
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                page:1,
                rows:11,
                pageTotal:0,
                index:0,
                selectColorGroup:1,
                isShowDrawer:false,
                payMoneyModal:false,
                detailModal:false,
                isShowPage:false,
                detailModalData:{},
                SupplierList:[],
                Bill:'',
                phone:'',//电话
                doorShip:JSON.parse(localStorage.getItem('shop')).name,
                SupplierName:'',//供应商名称
                SupplierId:null,//供应商id
                overdrawMonery:0,
                resultMoney:{},
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                columns: [
                    {title: '表单类型', key: 'tableType',align:'center' },
                    {title: '单据类型', key: 'buyType',align:'center' },
                    {title: '操作人', key: 'operator' ,align:'center' },
                    {title: '时间', key: 'time' ,align:'center' },
                    {title: '单号', key: 'order' ,align:'center',width:'220' },
                    {title: '应收金额', key: 'payMoney' ,align:'center' },
                    {title: '实收金额', key: 'actualMoney',align:'center'  },
                    {title: '应收余额', key: 'surplusSmoney',align:'center'  },
                    {title: '操作', key: 'edit' ,align:'center',slot: 'action',},
                ],
                data: [],
                BankList: [], //结算账户列表
                BankListValue:'',
                fuKanMsg:'',
                loadingTable:true,
                thisTruemoney:0,
                DrawerNamesPage:{
                    currpage:0,
                    page:1,
                    rows:7
                },
                DrawerNames:'',
                supplierOutMoney:0, //客户欠款
                totalMoneys:0,
                totalMoneys:0,
                totalNums:0,
                shopName:'',
                shopList: [],//店铺列表
                isCustomerSharing:0, //客户共享是否开启 0关 1开
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.isCustomerSharing = JSON.parse(localStorage.getItem('shop')).isCustomerSharing
            this.valuedate[0] = this.getDay(-7)
            this.valuedate[1] = this.nowTime
            this.getMoneyByDebt(this.index,this.DrawerNamesPage.page,this.DrawerNamesPage.rows)
            this.getBankList()//银行卡列表
            this.getShopList()
        },
        watch: {
            'DrawerNames': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getMoneyByDebt(this.index,this.DrawerNamesPage.page,this.DrawerNamesPage.rows)
                }
            },
            'phone': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getMoneyByDebt(this.index,this.DrawerNamesPage.page,this.DrawerNamesPage.rows)
                }
            },
            'shopName': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.sid = newVal
                    this.getMoneyByDebt(this.index,this.DrawerNamesPage.page,this.DrawerNamesPage.rows)
                }
            },
        },
        methods: {
            revoke(){
      MessageBox.confirm("撤销会影响历史数据，请谨慎处理").then(action => {
        this.isReturning = true;
        let data = {
          billMes: {
            ...this.billMes,
            state: 4
          },
        }
        if(this.inferiorFlag ==1){
          data.inferiorFlag = this.inferiorFlag
        }
        this.$axios
          .post("/invoicings/debt/updateDebt.action", data.billMes)
          .then(res => {
            this.isReturning = false;
            if (res.data.code == 200) {
              Toast("撤销成功");
              this.$route.query.item = 0;
              //返回上一页并刷新页面
              this.$router.go(-2);
            } else {
              Toast(res.data.msg);
            }
            
          })
          .catch(err => {
            this.isReturning = false;
          });
      });
            },
            getDay(day){
                var today = new Date();
                var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();
                var tMonth = today.getMonth();
                var tDate = today.getDate();
                tMonth = this.doHandleMonth(tMonth + 1);
                tDate = this.doHandleMonth(tDate);
                return tYear+"-"+tMonth+"-"+tDate;
            },
            doHandleMonth(month){
                var m = month;
                if(month.toString().length == 1){
                    m = "0" + month;
                }
                return m;
            },
//收款
            shoukuan(){
                this.payMoneyModal=true

                    this.thisTruemoney = 0-this.overdrawMonery

            },
            //客户列表
            getMoneyByDebt(index,page,row){
                this.$Api.getCustomerList({
                    cid: this.cid,
                    sid: this.sid,
                    name:this.DrawerNames,
                    page: page,
                    rows: row,
                    isdel:1,
                    phone:this.phone
                }).then(res => {
                    if(res.code==200){
                         this.SupplierList = res.data
                        this.supplierOutMoney= res.data.totalMoney
                        this.DrawerNamesPage.currpage=res.count
                        this.SupplierName =  this.SupplierList[index].name
                        this.SupplierId =  this.SupplierList[index].id
                        this.overdrawMonery=this.SupplierList[index].money
                        this.thisTruemoney=this.SupplierList[index].money
                        this.getDebtList(this.page,this.rows,this.valuedate[0],this.valuedate[1],this.SupplierId )
                        this.getSumDebt(this.page,this.rows,this.valuedate[0],this.valuedate[1],this.SupplierId )
                        this.getCustomerListData(index)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //店铺列表
            getShopList() {
                var data = {
                    cid: this.cid,
                    page: 1,
                    rows: 1000,
                };
                this.$Api.getShopList(data).then(res => {
                    this.shopList = res.data;
                    this.shopName = JSON.parse(localStorage.getItem('shop')).id
                });
            },
           //客户列表欠款
            getCustomerListData(index){
                this.$Api.getCustomerListData({
                    cid: this.cid,
                    sid: this.sid,
                    name:this.DrawerNames,
                    isdel:1
                }).then(res => {
                    if(res.code==200){
                         this.totalMoneys = res.data.totalMoney
                         this.totalNums = res.data.totalNum
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

            //修改供应商
            modifySupplierName(item,v){
                this.index=v
                this.SupplierName = item.name
                this.SupplierId = item.id
                this.overdrawMonery=item.money
                this.isShowDrawer=false
                this.getDebtList(this.page,this.rows,this.valuedate[0],this.valuedate[1],this.SupplierId )
                this.getSumDebt(this.page,this.rows,this.valuedate[0],this.valuedate[1],this.SupplierId )
            },
            exportExcel(startTime,endTime,customerid) {
                const params = {
                    cid: this.cid,
                    sid: this.sid,

                    status: 2,
                    state:this.Bill,
                    time:  startTime,
                    endtime: endTime,
                    customerid: customerid,          
            };
            exportExcel(this.$Api.exportDebtList, params, this.$Message, new Date().toLocaleString() + '客户对账');
        },
            //供应商单据列表
            getDebtList(page,rows,startTime,endTime,customerid){
                this.$Api.getDebtList({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    status: 2,
                    state:this.Bill,
                    time:  startTime,
                    endtime: endTime,
                    customerid: customerid,

                }).then(res => {
                    if(res.code==200){
                        this.data=[]
                        this.pageTotal = res.count

                        if(this.pageTotal>=11){
                            this.isShowPage=true
                        }else {
                            this.isShowPage=false
                        }
                        res.data.forEach((item,index)=>{
                            var PurchaseList={}
                            if(item.stateName !='付款单'){
                                PurchaseList.payMoney=item.shouldmoney
                                PurchaseList.surplusSmoney= item.surplusbalance
                            }else {
                                PurchaseList.payMoney='----'
                                PurchaseList.surplusSmoney= '----'
                            }
                            PurchaseList.buyType=item.stateName
                            PurchaseList.tableType =  item.statusName
                            PurchaseList.surplusSmoneys= item.surplusbalance
                            PurchaseList.bankName = item.bankName,
                            PurchaseList.id = item.ids,
                            PurchaseList.operator= item.adminname,
                            PurchaseList.time=item.time,
                            PurchaseList.order= item.code,
                            PurchaseList.actualMoney=item.truemoney,
                            PurchaseList.remark=item.remark,
                            PurchaseList.status=item.status,
                            PurchaseList.state=item.state,
                            this.data.push(PurchaseList)
                        })
                        this.loadingTable=false
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },

            getSumDebt(page,rows,startTime,endTime,customerid){
                if(this.Bill==0){
                    this.Bill=''
                }
                this.$Api.getSumDebt({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    status: 2,
                    state:this.Bill,
                    time:  startTime,
                    endtime: endTime,
                    customerid: customerid,
                }).then(res => {
                    if(res.code==200){
                        if(res.data!=null){
                            this.resultMoney = res.data
                        }else {
                            this.resultMoney.shouldmoney=0
                            this.resultMoney.truemoney=0
                            this.resultMoney.surplusbalance=0
                        }
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

            handleOk(data){
                this.valuedate[0] = data[0]
                this.valuedate[1] = data[1]
                this.getDebtList(this.page,this.rows,this.valuedate[0],this.valuedate[1],this.SupplierId)
                this.getSumDebt(this.page,this.rows,this.valuedate[0],this.valuedate[1],this.SupplierId )
            },

            goDetail(item){
                console.log(item)
                if(item.id==null){
                    this.detailModal=true
                    this.detailModalData = item
                }else {
                    this.$router.push(
                        {
                            path:'/salesListDetail',
                            query:{
                                id:item.id
                            }
                        })
                }
            },
            //获取银行卡
            getBankList(){
                this.$Api.getBankList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if(res.code==200){
                        this.BankList =  res.data

                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //分页
            onChangePage(num){
                this.getDebtList(num,this.rows,this.valuedate[0],this.valuedate[1],this.SupplierId )
            },
            onGongPageTotal(num){
                this.getMoneyByDebt(this.index,num,this.DrawerNamesPage.rows)
            },
            //付款确认
            payOk(){
                if(this.BankListValue==''){
                    this.$Message.warning('请选择结算账户');
                    return
                }

                this.$Api.addDebt({
                    cid: this.cid,
                    sid: this.sid,
                    bankid: this.BankListValue,//银行卡ID
                    customerid: this.SupplierId,//供应商id
                    tradetypeid: 2,
                    status: 2,
                    surplusbalance: this.overdrawMonery,//应付**
                    truemoney: this.thisTruemoney,//实收金额
                    adminid: JSON.parse(localStorage.getItem('adminUser')).id,
                    remark:this.fuKanMsg
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success('付款成功');
                        this.payMoneyModal=false
                        this.getDebtList(this.page,this.rows,this.valuedate[0],this.valuedate[1],this.SupplierId)
                        this.getSumDebt(this.page,this.rows,this.valuedate[0],this.valuedate[1],this.SupplierId )
                        this.getMoneyByDebt(this.index,this.DrawerNamesPage.page,this.DrawerNamesPage.rows)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },


        }
    };
</script>

<style lang="scss" scoped>
    .form-title{
        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        color: #ff5e5e;
    }
    .supplierList{
        background: #bfdeff;
        margin-top: 20px;
        border-left: 5px solid #ff7f7f;
        cursor: pointer;
    }
    .supplierList1{
        background: #fdc1c1;


    }
    .payMoneyModal-input{
        width: 200px;
    }

</style>